import { Trans } from '@lingui/react/macro';
import React from 'react';

import type { LatestMatchTeam } from 'modules/main/domain/interfaces/latest-match';
import UDText from 'ud-ui/components/text';
import TeamLogo from 'ud-ui/components/team-logo';
import { MATCH_PREVIEW_LOGO_SIZE, MATCH_PREVIEW_PLATE_CLASS } from './news-ticker-layout';

interface MatchPreviewProps {
  teams: [LatestMatchTeam, LatestMatchTeam];
}

interface TeamScoreProps {
  team: LatestMatchTeam;
}

/** Счёт одной команды под её эмблемой; «—», когда он неизвестен. */
function TeamScore({ team }: TeamScoreProps) {
  return (
    <UDText variant="text-2-bold" as="span" className="text-inkPrimary" data-testid="match-preview-score">
      {team.score ?? '—'}
    </UDText>
  );
}

/**
 * Превью матча: эмблема первой команды, «vs», эмблема второй; под каждой эмблемой — счёт её команды.
 * Эмблема — китовый `TeamLogo` в белом круге, с запасной картинкой для команды без эмблемы и для битой ссылки.
 */
function MatchPreview({ teams }: MatchPreviewProps) {
  return (
    <div data-testid="match-preview" className={MATCH_PREVIEW_PLATE_CLASS}>
      <div className="flex flex-col items-center gap-0.5">
        <TeamLogo url={teams[0].emblemUrl} size={MATCH_PREVIEW_LOGO_SIZE} shape="round" />
        <TeamScore team={teams[0]} />
      </div>
      <UDText variant="subtitle-2" as="span" className="text-inkMuted flex h-9 items-center">
        <Trans>vs</Trans>
      </UDText>
      <div className="flex flex-col items-center gap-0.5">
        <TeamLogo url={teams[1].emblemUrl} size={MATCH_PREVIEW_LOGO_SIZE} shape="round" />
        <TeamScore team={teams[1]} />
      </div>
    </div>
  );
}

export default MatchPreview;
